const ChevronUpIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="256" width="256" />
    <polyline
      fill="none"
      points="48 160 128 80 208 160"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);

const ChevronDownIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="256" width="256" />
    <polyline
      fill="none"
      points="208 96 128 176 48 96"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);

const CheckIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="256" width="256" />
    <polyline
      fill="none"
      points="40 144 96 200 224 72"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);

const ArrowLeft = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    fill="#000000"
    height="32"
    viewBox="0 0 256 256"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
  </svg>
);

const ArrowRight = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    fill="#000000"
    height="32"
    viewBox="0 0 256 256"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
  </svg>
);

const CaretSortIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="256" width="256" />
    <polyline
      fill="none"
      points="80 176 128 224 176 176"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <polyline
      fill="none"
      points="80 80 128 32 176 80"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);

const ChevronRightIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="256" width="256" />
    <polyline
      fill="none"
      points="96 48 176 128 96 208"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);

const DotFilledIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="256" width="256" />
    <circle cx="128" cy="128" r="12" />
  </svg>
);

const XIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    {...otherProps}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
  >
    <rect width="256" height="256" fill="none" />
    <line
      x1="200"
      y1="56"
      x2="56"
      y2="200"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <line
      x1="200"
      y1="200"
      x2="56"
      y2="56"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);

const DotsThreeIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <rect fill="none" height="256" width="256" />
    <circle cx="128" cy="128" r="12" />
    <circle cx="196" cy="128" r="12" />
    <circle cx="60" cy="128" r="12" />
  </svg>
);

const MagnifyingGlassIcon = ({ className, ...otherProps }: React.ComponentProps<"svg">) => (
  <svg
    className={className}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <rect fill="none" height="256" width="256" />
    <circle
      cx="112"
      cy="112"
      fill="none"
      r="80"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
      x1="168.57"
      x2="224"
      y1="168.57"
      y2="224"
    />
  </svg>
);

export {
  ArrowLeft,
  ArrowRight,
  CaretSortIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  DotFilledIcon,
  DotsThreeIcon,
  MagnifyingGlassIcon,
  XIcon,
};
